import React, { Component } from "react";
import NavbarBrand from "../../images/pitx_logo.png";
import NavbarAsset from "../../images/redassetmegawide.PNG";
import { Transition, animated } from "react-spring/renderprops";

import { AzureAD, AuthenticationState } from "react-aad-msal";
import { authProvider } from "../../authProvider";

import { Link } from "react-router-dom";
import "./Sidenav.css";
import pdfGuide from "../../pdf/userGuide.pdf";
import axios from "axios";
import pitxLogo from "../../images/pitx_logo.png";

import AdminModal from "../MasterData/adminModal";
import { CrfContext } from "../../CrfContext";
import Backdrop from "../controlledBackdrop/backdrop";
import { Button } from "@material-ui/core";
export class SideNav extends Component {
  state = {
    btn1List: false,
    btn2List: false,
    btn3List: false,
    userName: "",
    email: "",
    userDepartment: "",
    userRole: "",
    isLoading: true,
    modal: false,
  };

  toggleBtn1List = () => {
    this.setState({ btn1List: !this.state.btn1List, btn2List: false });
    document.getElementById("navlist1").style.height = "auto";
    document.getElementById("navlist1").style.transition = "0.5s";
    if (this.state.userRole !== "Department Head") {
      document.getElementById("navLink2Asset").style.display = "block";
    }
    document.getElementById("navLink1Asset").style.display = "none";
    if (this.state.btn1List === true) {
      document.getElementById("navlist1").style.height = "60px";
      document.getElementById("navLink1Asset").style.display = "block";
    }
  };

  toggleBtn2List = () => {
    this.setState({ btn2List: !this.state.btn2List, btn1List: false });
    document.getElementById("navlist2").style.height = "auto";
    document.getElementById("navlist2").style.transition = "0.5s";
    document.getElementById("navLink1Asset").style.display = "block";
    document.getElementById("navLink2Asset").style.display = "none";
    if (this.state.btn2List === true) {
      document.getElementById("navlist2").style.height = "60px";
      document.getElementById("navLink2Asset").style.display = "block";
    }
  };

  toggleBtn3List = () => {
    this.setState({
      btn3List: !this.state.btn3List,
      btn2List: false,
      btn1List: false,
    });
    document.getElementById("navlist3").style.height = "auto";
    document.getElementById("navlist3").style.transition = "0.5s";
    document.getElementById("navLink1Asset").style.display = "block";
    document.getElementById("navLink2Asset").style.display = "none";
    if (this.state.btn2List === true) {
      document.getElementById("navlist3").style.height = "60px";
      document.getElementById("navLink3Asset").style.display = "block";
    }
  };

  handleLogout = (logout) => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("userFirstName");
    localStorage.removeItem("userLastName");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("token");
    logout();
    window.location.reload();
  };

  // componentWillUnmount(){
  //   if(this.props.btn1List === true){
  //     document.getElementById('navLink1Asset').style.display = 'none'
  //     document.getElementById("navlist1").style.height = "auto";
  //   }
  // }

  componentDidMount() {
    this.setState({ isLoading: true });
    axios({
      method: "GET",
      url: `${process.env.REACT_APP_API_KEY}/api/userInfo`,
      headers: {
        "Api-Key":
          "2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130",
        Authorization: `Bearer ${localStorage.token}`,
      },
    })
      .then((response) => {
        // const data = response.data.data
        this.setState({
          // userName: (data.firstName).substring(0,1) + " " +
          // data.lastName,
          userName:
            response.data.data.firstName.substring(0, 1) +
            " " +
            response.data.data.lastName,
          userRole: response.data.data.roles[0],
          email: response.data.data.email,
        });

        if (response.data.data.departments) {
          this.setState({
            userDepartment: response.data.data.departments[0].centerName,
          });
        }
        this.setState({ isLoading: false });
      })
      .catch((error) => {
        const { data } = error.response;
        if (data.error === "jwt expired") {
          alert("Session expired");
          localStorage.removeItem("token");
          window.location.reload();
        }
        this.setState({ isLoading: false });
      });
  }

  render() {
    let links = "";
    let navLinkAsset1 = "";
    let requestorLink1 = (
      <div className="navLinks1">
        <Link to="/RequestSelection">
          <div className="navLink">
            <h5 className="navLinkText">
              <i className="fas fa-file-alt"></i>
              Create Request
            </h5>
          </div>
        </Link>
        <Link to="/MyRequest">
          <div className="navLink">
            <h5 className="navLinkText">
              <i class="fas fa-table"></i>My Requests
            </h5>
          </div>
        </Link>
        <Link to="/Drafts">
          <div className="navLink">
            <h5 className="navLinkText">
              <i class="fas fa-save"></i>Draft
            </h5>
          </div>
        </Link>
        <Link to="/Returned">
          <div className="navLink">
            <h5 className="navLinkText">
              <i class="fas fa-thumbs-down"></i>Returned
            </h5>
          </div>
        </Link>
        <Link to="/Rejected">
          <div className="navLink" style={lastLink1}>
            <h5 className="navLinkText">
              <i class="fas fa-trash"></i>Rejected
            </h5>
          </div>
        </Link>
      </div>
    );
    //   

    if (
      this.state.userRole === "Requestor" ||
      this.state.userRole === "Treasury" ||
      this.state.userRole === "Requestor / Exec. Secretary"
    ) {
      navLinkAsset1 = (
        <small id="navLink1Asset">Create Request, My Requests....</small>
      );

      links = (
        <div className="navLinks1">
          <Link to="/RequestSelection">
            <div className="navLink">
              <h5 className="navLinkText">
                <i className="fas fa-plus"></i>
                Create Request
              </h5>
            </div>
          </Link>
          <Link to="/MyRequest">
            <div className="navLink">
              <h5 className="navLinkText">
                <i class="fas fa-table"></i>My Requests
              </h5>
            </div>
          </Link>
          <Link to="/Drafts">
            <div className="navLink" style={lastLink1}>
              <h5 className="navLinkText">
                <i class="fas fa-file-alt"></i>Draft
              </h5>
            </div>
          </Link>
          {this.state.userRole === "Requestor / Exec. Secretary" ? (
            <>
              <Link to="/ToApprove">
                <div className="navLink" style={lastLink1}>
                  <h5 className="navLinkText">
                    <i class="fas fa-exclamation"></i>CEA Request Approvals
                  </h5>
                </div>
              </Link>
            </>
          ) : (
            ""
          )}
          {/* <Link to="/Returned">
                           <div className="navLink">
                             <h5 className="navLinkText">
                               <i class="fas fa-thumbs-down"></i>Returned
                             </h5>
                           </div>
                         </Link>
                         <Link to="/Rejected">
                           <div className="navLink" style={lastLink1}>
                             <h5 className="navLinkText">
                               <i class="fas fa-trash"></i>Rejected
                             </h5>
                           </div>
                         </Link> */}
        </div>
      );
    }

    if (this.state.userRole === "Department Head") {
      navLinkAsset1 = (
        <small id="navLink1Asset">
          {/* Create Request, MyRequests, Draft.... */}
          To Approve, Approved, Returned ....
        </small>
      );

      links = (
        <div className="navLinks1">
          <Link to="/ToApprove">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i className="fas fa-file-alt"></i> */}
                To Approve
              </h5>
            </div>
          </Link>
          <Link to="/Approved">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                Approved
              </h5>
            </div>
          </Link>
          <Link to="/Returned">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-save"></i> */}
                Returned
              </h5>
            </div>
          </Link>
          <Link to="/Rejected">
            <div className="navLink" style={lastLink1}>
              <h5 className="navLinkText">
                {/* <i class="fas fa-thumbs-down"></i> */}
                Rejected
              </h5>
            </div>
          </Link>
        </div>
      );
    }

    if (this.state.userRole === "CEA") {
      navLinkAsset1 = (
        <small id="navLink1Asset">
          {/* Create Request, MyRequests, Draft.... */}
          To Approve, Approved, Returned ....
        </small>
      );

      links = (
        <div className="navLinks1">
          <Link to="/ToApprove">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i className="fas fa-file-alt"></i> */}
                To Approve
              </h5>
            </div>
          </Link>
          <Link to="/Approved">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                Approved
              </h5>
            </div>
          </Link>
          <Link to="/Returned">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-save"></i> */}
                Returned
              </h5>
            </div>
          </Link>
          <Link to="/Rejected">
            <div className="navLink" style={lastLink1}>
              <h5 className="navLinkText">
                {/* <i class="fas fa-thumbs-down"></i> */}
                Rejected
              </h5>
            </div>
          </Link>
        </div>
      );
    }

    if (this.state.userRole === "President") {
      navLinkAsset1 = (
        <small id="navLink1Asset">
          {/* Create Request, MyRequests, Draft.... */}
          To Approve, Approved, Returned ....
        </small>
      );

      links = (
        <div className="navLinks1">
          <Link to="/ToApprove">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i className="fas fa-file-alt"></i> */}
                To Approve
              </h5>
            </div>
          </Link>
          <Link to="/Approved">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                Approved
              </h5>
            </div>
          </Link>
        </div>
      );
    }

    if (this.state.userRole === "Accounting Staff") {
      navLinkAsset1 = (
        <small id="navLink1Asset">
          {/* Create Request, MyRequests, Draft.... */}
          To Approve, Approved, Returned ....
        </small>
      );

      links = (
        <div className="navLinks1">
          <Link to="/ForTransmittal">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i className="fas fa-file-alt"></i> */}
                For Transmittal
              </h5>
            </div>
          </Link>
          <Link to="/ForReview">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                ForReview
              </h5>
            </div>
          </Link>
          <Link to="/Reviewed">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                Reviewed
              </h5>
            </div>
          </Link>
          <Link to="/Returned">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-save"></i> */}
                Returned
              </h5>
            </div>
          </Link>
          <Link to="/Rejected">
            <div className="navLink" style={lastLink1}>
              <h5 className="navLinkText">
                {/* <i class="fas fa-thumbs-down"></i> */}
                Rejected
              </h5>
            </div>
          </Link>
        </div>
      );
    }

    if (this.state.userRole === "Accounting Supervisor") {
      navLinkAsset1 = (
        <small id="navLink1Asset">
          {/* Create Request, MyRequests, Draft.... */}
          To Approve, Approved, Returned ....
        </small>
      );

      links = (
        <div className="navLinks1">
          <Link to="/ForTransmittal">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i className="fas fa-file-alt"></i> */}
                For Transmittal
              </h5>
            </div>
          </Link>
          <Link to="/ForReview">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                ForReview
              </h5>
            </div>
          </Link>
          <Link to="/Reviewed">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                Reviewed
              </h5>
            </div>
          </Link>
          <Link to="/Returned">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-save"></i> */}
                Returned
              </h5>
            </div>
          </Link>
          <Link to="/Rejected">
            <div className="navLink" style={lastLink1}>
              <h5 className="navLinkText">
                {/* <i class="fas fa-thumbs-down"></i> */}
                Rejected
              </h5>
            </div>
          </Link>
        </div>
      );
    }

    if (this.state.userRole === "Accounting Manager") {
      navLinkAsset1 = (
        <small id="navLink1Asset">
          {/* Create Request, My Requests.... */}
          All Requests, For Endorsement ....
        </small>
      );

      links = (
        <div className="navLinks1">
          <Link to="/AllRequests">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i className="fas fa-file-alt"></i> */}
                All Requests
              </h5>
            </div>
          </Link>
          <Link to="/ForEndorsement">
            <div className="navLink">
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                For Endorsement
              </h5>
            </div>
          </Link>
          <Link to="/Onhold">
            <div className="navLink" style={lastLink1}>
              <h5 className="navLinkText">
                {/* <i class="fas fa-table"></i> */}
                On Hold
              </h5>
            </div>
          </Link>
        </div>
      );
    }

    return (
      <>
        <CrfContext.Consumer>
          {(context) => (
            <div className="sideNav">
              <Backdrop open={this.state.isLoading} />
              <div className="sideNavHeader">
                <Link to="/">
                  <img className="navBarBrand" src={NavbarBrand} alt="" />
                </Link>
              </div>
              <div className="userInfoContainer">
                <div className="userContent">
                  <div className="userIconNav">
                    <div className="userIconContainer">
                      <i id="userIcon" className="fas fa-user-circle"></i>
                    </div>
                  </div>
                  <div className="userInfoNav">
                    <p>{this.state.userName}</p>
                    <span></span>
                    <small>{this.state.userRole}</small>
                  </div>
                </div>
              </div>

              {this.state.userRole === "Accounting Staff" ||
              this.state.userRole === "Treasury" ||
              this.state.userRole === "Accounting Supervisor" ? (
                <div className="navLinkGroup2">
                  <Link to="/MyDashboard">
                    <div
                      id="navlist2"
                      className="navLinkGroupHeader2"
                      // onClick={this.handleLogout}
                    >
                      <h4>My Dashboard</h4>
                    </div>
                  </Link>
                </div>
              ) : null}

              <div
                className="navLinkGroup2"
                style={
                  this.state.userRole === "Accounting Staff" ||
                  this.state.userRole === "Accounting Supervisor"
                    ? {}
                    : { display: "none" }
                }
              >
                <div
                  id="navlist2"
                  className="navLinkGroupHeader2"
                  onClick={() => {
                    this.setState({ modal: true });
                  }}
                >
                  <h3>Master Data</h3>
                </div>
              </div>
              <AdminModal
                fullScreen
                title="Master Data"
                handleClose={() => {
                  this.setState({ modal: false });
                }}
                open={this.state.modal}
              />

              {this.state.userRole !== "Accounting Staff" ||
              this.state.userRole !== "Accounting Supervisor" ? (
                <div className="navLinkGroup1">
                  <div
                    id="navlist1"
                    className="navLinkGroupHeader1"
                    onClick={this.toggleBtn1List}
                  >
                    <h3>Request</h3>
                    {/* <small id="navLink1Asset">
                 Create Request, MyRequests....
               </small> */}
                    {navLinkAsset1}
                  </div>
                  <div className="navLinks1Container">
                    <Transition
                      native
                      items={this.state.btn1List}
                      from={{ opacity: 1, marginTop: 0 }}
                      enter={{ opacity: 1, marginTop: 0 }}
                      leave={{ opacity: 0, marginTop: -500 }}
                      // config={{ duration: 300 }}
                    >
                      {(show) =>
                        show &&
                        ((props) => (
                          <animated.div style={props}>
                            {/* NavLinks1 */}
                            {links}
                          </animated.div>
                        ))
                      }
                    </Transition>
                  </div>
                </div>
              ) : null}

              {this.state.userRole !== "Department Head" &&
              this.state.userRole !== "Accounting Staff" &&
              this.state.userRole !== "Accounting Supervisor" ? (
                <div className="navLinkGroup2">
                  <div
                    id="navlist2"
                    className="navLinkGroupHeader2"
                    // onClick={this.toggleBtn2List}
                    onClick={() => {
                      this.state.userRole === "Requestor" ||
                      this.state.userRole === "Treasury" ||
                      this.state.userRole === "Requestor / Exec. Secretary"
                        ? alert("Must have System Administator Role")
                        : this.toggleBtn2List();
                    }}
                  >
                    {this.state.userRole === "Requestor" ||
                    this.state.userRole === "Treasury" ||
                    this.state.userRole === "Requestor / Exec. Secretary" ? (
                      <h3>Settings</h3>
                    ) : (
                      <h3>Checks</h3>
                    )}

                    {this.state.userRole !== "Requestor" ? (
                      <small id="navLink2Asset">
                        In Process, Check Preparation, Ch....
                      </small>
                    ) : (
                      <small id="navLink2Asset">My Departments</small>
                    )}
                  </div>
                  <div className="navLinks2Container">
                    <Transition
                      native
                      items={this.state.btn2List}
                      from={{ opacity: 0, marginTop: -500 }}
                      enter={{ opacity: 1, marginTop: 0 }}
                      leave={{ opacity: 0, marginTop: -500 }}
                      config={{ duration: 300 }}
                    >
                      {(show) =>
                        show &&
                        ((props) => (
                          <animated.div style={props}>
                            {this.state.userRole !== "Requestor" ? (
                              <div className="navLinks2">
                                <Link to="/InProcess">
                                  <div className="navLink">
                                    <h5 className="navLinkText">
                                      <i className="fas fa-file-alt"></i>
                                      In Process
                                    </h5>
                                  </div>
                                </Link>
                                <Link to="/CheckPreparation">
                                  <div className="navLink">
                                    <h5 className="navLinkText">
                                      <i class="fas fa-table"></i>Check
                                      Preparation
                                    </h5>
                                  </div>
                                </Link>
                                <Link to="/CheckPrepared">
                                  <div className="navLink">
                                    <h5 className="navLinkText">
                                      <i class="fas fa-table"></i>Check Prepared
                                    </h5>
                                  </div>
                                </Link>
                                <Link to="/CheckAvailable">
                                  <div className="navLink">
                                    <h5 className="navLinkText">
                                      <i class="fas fa-save"></i>Check Available
                                    </h5>
                                  </div>
                                </Link>
                                <Link to="/Released">
                                  <div className="navLink" style={lastLink1}>
                                    <h5 className="navLinkText">
                                      <i class="fas fa-thumbs-up"></i>Released
                                    </h5>
                                  </div>
                                </Link>
                              </div>
                            ) : (
                              <div className="navLinks2">
                                {/* <Link to='/MyDepartments'> */}
                                <div
                                  className="navLink"
                                  style={lastLink1}
                                  onClick={() => {
                                    alert(
                                      "Must have System Administrator Role"
                                    );
                                  }}
                                >
                                  <h5 className="navLinkText">
                                    <i class="fas fa-users"></i>
                                    Departments
                                  </h5>
                                </div>
                                {/* </Link> */}
                                {/* <Link to="/CheckPreparation">
                       <div className="navLink">
                         <h5 className="navLinkText">
                           <i class="fas fa-table"></i>Check Preparation
                         </h5>
                       </div>
                     </Link>
                     <Link to="/CheckAvailable">
                       <div className="navLink">
                         <h5 className="navLinkText">
                           <i class="fas fa-save"></i>Check Available
                         </h5>
                       </div>
                     </Link>
                     <Link to="/Released">
                       <div className="navLink" style={lastLink1}>
                         <h5 className="navLinkText">
                           <i class="fas fa-thumbs-up"></i>Released
                         </h5>
                       </div>
                     </Link> */}
                              </div>
                            )}
                          </animated.div>
                        ))
                      }
                    </Transition>
                  </div>
                </div>
              ) : null}

              {this.state.userRole === "Department Head" ? (
                // <Link to='/ApproveDepartment' style={textDecoration}>
                <div
                  className="navLinkGroup2"
                  onClick={() => {
                    alert("Must have System Administrator Role");
                  }}
                >
                  <div id="navlist2" className="navLinkGroupHeader2">
                    {/* <h3>{this.state.userDepartment}</h3> */}
                    <h3>Dept. Management</h3>
                  </div>
                </div>
              ) : // </Link>
              null}

              {this.state.email === "rjacain@megawide.com.ph" &&
              this.state.userRole === "Department Head" ? (
                <>
                  <div
                    className="navLinkGroup2"
                    style={
                      // this.state.email === 'rjacain@megawide.com.ph' && this.state.userRole === 'Department Head'
                      this.state.email === "mcortez@megawide.com.ph" &&
                      this.state.userRole === "Department Head"
                        ? {}
                        : { display: "none" }
                    }
                  >
                    <div
                      id="navlist2"
                      className="navLinkGroupHeader2"
                      onClick={() => {
                        this.setState({ modal: true });
                      }}
                    >
                      <h3>Master Data</h3>
                    </div>
                  </div>
                  <AdminModal
                    fullScreen
                    title="Master Data"
                    handleClose={() => {
                      this.setState({ modal: false });
                    }}
                    open={this.state.modal}
                  />
                </>
              ) : null}

              {/* ============================================= ACCOUNTING MANAGER ============================== */}
              {this.state.userRole === "Accounting Manager" ? (
                <div className="navLinkGroup2">
                  <div
                    id="navlist3"
                    className="navLinkGroupHeader2"
                    onClick={() => {
                      alert("Must have System Administrator Role");
                    }}
                    // onClick={this.toggleBtn3List}
                  >
                    <h3>System</h3>
                    <small id="navLink3Asset">System Users, Reports....</small>
                  </div>
                  <div className="navLinks3Container">
                    <Transition
                      native
                      items={this.state.btn3List}
                      from={{ opacity: 0, marginTop: -500 }}
                      enter={{ opacity: 1, marginTop: 0 }}
                      leave={{ opacity: 0, marginTop: -500 }}
                      config={{ duration: 300 }}
                    >
                      {(show) =>
                        show &&
                        ((props) => (
                          <animated.div style={props}>
                            <div className="navLinks3">
                              <Link to="/SystemUsers">
                                <div className="navLink">
                                  <h5 className="navLinkText">
                                    <i class="fas fa-save"></i>System Users
                                  </h5>
                                </div>
                              </Link>
                              <Link to="/Reports">
                                <div className="navLink" style={lastLink1}>
                                  <h5 className="navLinkText">
                                    <i class="fas fa-thumbs-up"></i>Reports
                                  </h5>
                                </div>
                              </Link>
                            </div>
                          </animated.div>
                        ))
                      }
                    </Transition>
                  </div>
                </div>
              ) : null}

              {/* =================================================END =============================================================== */}

              {/* Logout Button */}

              <div className="navLinkGroup2">
                <div
                  id="navlist2"
                  className="navLinkGroupHeader2"
                  onClick={() => {}}
                >
                  <h3>
                    <a
                      href={pdfGuide}
                      target="_blank"
                      style={{ display: "block", padding: ".5rem 0" }}
                    >
                      User Manual
                    </a>
                  </h3>
                </div>
              </div>

              <div
                className="navLinkGroup2"
                style={
                  this.state.userRole === "Accounting Manager"
                    ? {}
                    : { display: "none" }
                }
              >
                <div
                  id="navlist2"
                  className="navLinkGroupHeader2"
                  onClick={() => {
                    this.setState({ modal: true });
                  }}
                >
                  <h3>Master Data</h3>
                </div>
              </div>
              <AdminModal
                fullScreen
                title="Master Data"
                handleClose={() => {
                  this.setState({ modal: false });
                }}
                open={this.state.modal}
              />
              <div className="navLinkGroup2">
                <AzureAD provider={authProvider}>
                  {({ logout }) => {
                    return (
                      <div
                        id="navlist2"
                        className="navLinkGroupHeader2"
                        onClick={() => this.handleLogout(logout)}
                      >
                        <h3>Logout</h3>
                      </div>
                    );
                  }}
                </AzureAD>
              </div>

              {/*End Logout Button */}

              <img className="navbarAsset" src={NavbarAsset} alt="" />
            </div>
          )}
        </CrfContext.Consumer>
      </>
    );
  }
}

const lastLink1 = {
  marginBottom: "20px",
};

const textDecoration = {
  textDecoration: "none",
};

export default SideNav;
